export const products = [
    {
      id: 1,
      name: "Hyaluronic acid (HMW) ",
      price: 250000, 
      unit: "per kg",
      category: "Hyaluronic acids",
      image: "/assets/Hyaluronic acid (LMW)2.png",
      description: "High-molecular-weight hyaluronic acid that provides long-lasting hydration, enhances skin smoothness, and boosts elasticity in moisturizing formulations."
    },
    {
      id: 2,
      name: "Hyaluronic acid (LMW)",
      price: 300000,
      unit: "per kg",
      category: "Hyaluronic acids",
      image: "/assets/Hyaluronic acid (HMW)2.png",
      description: "Low-molecular-weight hyaluronic acid that penetrates deeper into the skin to provide intense hydration, improve elasticity, and support anti-aging formulations."
    },
    {
      id: 3,
      name: "Ferulic Acid",
      price: 150000,
      unit: "per kg",
      category: "Actives",
      image: "/assets/Ferulic Acid2.png",
      description: "A powerful antioxidant that enhances the stability and effectiveness of vitamins C & E while protecting skin from environmental damage."
    },
    {
      id: 4,
      name: "Bromelin enzyme",
      price: 65000,
      unit: "per kg",
      category: "Powders/Enzymes",
      image: "/assets/Bromelin enzyme2.png",
      description: "A natural exfoliating enzyme derived from pineapple that gently removes dead skin cells and promotes smoother, brighter skin."
    },
    {
      id: 5,
      name: "Papain enzyme",
      price: 35000,
      unit: "per kg",
      category: "Powders/Enzymes",
      image: "/assets/Papain enzyme2.png",
      description: "A mild, plant-based exfoliating enzyme from papaya used to improve skin texture and clarity."
    },
    {
      id: 6,
      name: "Mequinol",
      price: 80000,
      unit: "per kg",
      category: "Powders/Enzymes",
      image: "/assets/Mequinol3.png",
      description: "A skin-lightening active used to reduce dark spots, hyperpigmentation, and uneven skin tone."
    },

    {
        id: 7,
        name: "Azelaic acid",
        price: 55000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Azelaic acid2.png",
        description: "A multifunctional brightening and anti-inflammatory ingredient that helps treat acne, reduce redness, and fade dark spots."
      },

      {
        id: 8,
        name: "Odour Shield (zinc ricinoleate) ",
        price: 65000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Odour Shield (zinc ricinoleate)2.png",
        description: "An effective deodorizing agent that traps and neutralizes odors without disrupting natural skin microbiome."
      },

      {
        id: 9,
        name: "Zinc PCA",
        price: 170000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Zinc PCA2.png",
        description: "A soothing and oil-regulating active that reduces sebum production and supports acne-prone skin."
      },

      {
        id: 10,
        name: "Crothix",
        price: 65000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Crothix3.png",
        description: "A liquid thickener that increases the viscosity of surfactant systems while improving clarity and stability."
      },

      {
        id: 11,
        name: "Sepi White MSH ",
        price: 400000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Sepi White MSH2.png",
        description: "A premium brightening active that targets pigmentation and helps achieve an even, radiant complexion."
      },

      {
        id: 12,
        name: "Symwhite",
        price: 350000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Symwhite2.png",
        description: "A powerful antioxidant and brightening ingredient that reduces discoloration and supports a more luminous skin tone."
      },

      {
        id: 13,
        name: "Alpha Arbutin",
        price: 150000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Alpha Arbutin2.png",
        description: "A gentle and highly effective skin-brightening active used to fade dark spots and even out skin tone."
      },

      {
        id: 14,
        name: "Kojic dipalmitate",
        price: 75000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Kojic dipalmitate2.png",
        description: "A stable, oil-soluble brightening agent that helps reduce pigmentation and promote a more uniform complexion."
      },

      {
        id: 15,
        name: "Gluconolactone",
        price: 20000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Gluconolactone2.png",
        description: "A gentle PHA that exfoliates, hydrates, and supports sensitive skin while improving overall texture."
      },

      {
        id: 16,
        name: "Yeast beta glucan",
        price: 65000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Yeast beta clucan3.png",
        description: "A soothing, protective ingredient that enhances skin repair and boosts moisture retention."
      },


      {
        id: 17,
        name: "Oat beta glucan ",
        price: 65000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Oat beta clucan3.png",
        description: "A calming, hydrating active known for reducing irritation and strengthening the skin barrier."
      },


      {
        id: 18,
        name: "Silky peptide",
        price: 100000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Silky peptide2.png",
        description: "A smoothing peptide that enhances skin softness, texture, and overall appearance."
      },

      {
        id: 19,
        name: "Lotionpro",
        price: 15000,
          unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Lotionpro2.png",
        description: "A premium emulsifier that creates stable, silky lotions and creams with excellent skin feel.."
      },

      {
        id: 20,
        name: "DL-Panthenol powder",
        price: 55000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/DL-Panthenol powder2.png",
        description: "A pro-vitamin B5 active that hydrates, soothes, and improves skin elasticity."
      },


      {
        id: 21,
        name: "Beeswax",
        price: 8500,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Beeswax2.png",
        description: "A natural thickener and stabilizer that provides structure, moisture barrier protection, and a smooth texture."
      },

      {
        id: 22,
        name: "Clotrimazole",
        price: 70000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Clotrimazole2.png",
        description: "An antifungal active used to treat and prevent fungal skin infections."
      },


      {
        id: 23,
        name: "Xanthan gum",
        price: 8000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Xanthan gum2.png",
        description: "A natural thickener that stabilizes gels, creams, and serums with excellent consistency control"
      },

      {
        id: 24,
        name: "Bentonite clay",
        price: 3000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Bentonite clay2.png",
        description: "A detoxifying clay that absorbs excess oil and impurities, ideal for masks and deep-cleansing formulations."
      },


      {
        id: 25,
        name: "HEC",
        price: 18000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/HEC2.png",
        description: "A thickening agent that enhances viscosity and texture in gels, cleansers, and serums."
      },

      {
        id: 26,
        name: "Allantoin",
        price: 15000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Allantoin2.png",
        description: "A soothing and healing ingredient that calms irritation and promotes skin repair."
      },

      {
        id: 27,
        name: "Niacinamide",
        price: 20000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Niacinamide2.png",
        description: "A versatile active that improves skin tone, strengthens the barrier, reduces oil, and fades dark spots."
      },

      {
        id: 28,
        name: "Phenoxyethanol",
        price: 17000,
        unit: "per kg",
        category: "Powders/Enzymes",
        image: "/assets/Phenoxyethanol.png",
        description: "A widely used preservative that protects formulas from contamination and extends shelf life."
      },

      {
        id: 29,
        name: "Azone oil",
        price: 45000,
        unit: "per liter",
        category: "Liquids/Oils",
        image: "/assets/Azone oil2.png",
        description: "Deep hydration and long-lasting softness."
      },


      {
        id: 30,
        name: "Alpha Bisabolol",
        price: 300000,
         unit: "per liter",
        category: "Liquids/Oils",
        image: "/assets/Alpha Bisabolol3.png",
        description: "A calming, anti-inflammatory ingredient that reduces redness and sensitivity."
      },

      {
        id: 31,
        name: "Snail filtrate",
        price: 70000,
        unit: "per liter",
        category: "Liquids/Oils",
        image: "/assets/Snail filtrate2.png",
        description: "A hydrating and repairing active that promotes smoothness, elasticity, and skin regeneration."
      },

      {
        id: 32,
        name: "Astaxantin oil",
        price: 100000,
        unit: "per liter",
        category: "Liquids/Oils",
        image: "/assets/Astaxantin oil2.png",
        description: "A potent antioxidant oil that protects skin from oxidative stress and supports anti-aging benefits."
      },

      {
        id: 33,
        name: "Bergamot oil",
        price: 70000,
        unit: "per liter",
        category: "Liquids/Oils",
        image: "/assets/Bergamot oil2.png",
        description: "A refreshing essential oil with antibacterial and balancing properties."
      },

      {
        id: 34,
        name: "Teatree essential oil",
        price: 70000,
        unit: "per liter",
        category: "Liquids/Oils",
        image: "/assets/Teatree essential oil2.png",
        description: "A powerful antimicrobial essential oil ideal for acne-prone and reactive skin."
      },


      {
        id: 35,
        name: "Geranium Essential Oil",
        price: 80000,
        unit: "per liter",
        category: "Liquids/Oils",
        image: "/assets/Geranium Essential Oil2.png",
        description: "A balancing essential oil that supports skin regeneration and helps regulate oil production."
      },


      {
        id: 36,
        name: "Lavender essential oil",
        price: 45000,
        unit: "per liter",
        category: "Liquids/Oils",
        image: "/assets/Lavender essential oil2.png",
        description: "A calming essential oil known for soothing skin and reducing irritation."
      },

      {
        id: 37,
        name: "Polyquat 7",
        price: 12000,
        unit: "per liter",
        category: "Liquids/Oils",
        image: "/assets/Polyquat 72.png",
        description: "A conditioning agent that improves softness and detangling in haircare formulations."
      },

      {
        id: 38,
        name: "Polysorbate 80",
        price: 10000,
        unit: "per liter",
        category: "Liquids/Oils",
        image: "/assets/Polysorbate 802.png",
        description: "A solubilizer and emulsifier used to blend oils with water in sprays, serums, and cleansers."
      },

      {
        id: 39,
        name: "Caprylic triglycerides",
        price: 28000,
        unit: "per liter",
        category: "Liquids/Oils",
        image: "/assets/Caprylic triglycerides2.png",
        description: "A lightweight, non-greasy emollient that softens skin and enhances product glide."
      },


      {
        id: 40,
        name: "PEG 40 (hydrogenated castor) ",
        price: 20000,
        unit: "per liter",
        category: "Liquids/Oils",
        image: "/assets/PEG 40 (hydrogenated castor)2.png",
        description: "A solubilizer used to blend essential oils, fragrances, and actives into water-based formulas."
      },

      {
        id: 41,
        name: "PEG 7",
        price: 15000,
        unit: "per liter",
        category: "Liquids/Oils",
        image: "/assets/PEG 72.png",
        description: "A mild emollient and surfactant that adds softness and improves skin feel."
      },


      {
        id: 42,
        name: "Sepi Max Zen",
        price: 20000,
        unit: "per 100g",
        category: "Liquids/Oils",
        image: "/assets/Sepi Max Zen2.png",
        description: "A premium polymer that creates elegant, smooth gel creams with high stability and clarity."
      },

      {
        id: 43,
        name: "Thiamidol ",
        price: 190000,
        unit: "per 100g",
        category: "Liquids/Oils",
        image: "/assets/Thiamidol2.png",
        description: "A highly advanced brightening active that targets dark spots with clinical effectiveness."
      },


      {
        id: 44,
        name: "Matrixyl 3000 ",
        price: 30000,
        unit: "per liter",
        category: "Liquids/Oils",
        image: "/assets/Matrixyl 30002.png",
        description: "A peptide complex that boosts collagen production and reduces visible signs of aging."
      },


      {
        id: 45,
        name: "Acetyl hexapeptide-8",
        price: 20000,
        unit: "per 100ml",
        category: "Liquids/Oils",
        image: "/assets/Acetyl hexapeptide-82.png",
        description: "A well-known peptide that softens expression lines and supports anti-aging formulations."
      },


      {
        id: 46,
        name: "Dl Panthenol liquid",
        price: 45000,
        unit: "per Kg",
        category: "Liquids/Oils",
        image: "/assets/Dl Panthenol liquid.png",
        description: "A highly effective moisturizing and soothing ingredient known for improving skin hydration, enhancing softness, and supporting the skin barrier. Commonly used in lotions, serums, and haircare for its conditioning benefits."
      },



      {
        id: 47,
        name: "Nag",
        price: 90000,
        unit: "per kg",
        category: "Powder/Enzyme",
        image: "/assets/Nag.png",
        description: "A skin-brightening and barrier-strengthening ingredient that helps reduce hyperpigmentation, evens skin tone, and boosts natural hyaluronic acid production. Gentle and suitable for sensitive skin."
      },

      {
        id: 48,
        name: "C13-C15 alkyl benzoate",
        price: 35000,
        unit: "per kg",
        category: "Powders/Enzyme",
        image: "/assets/C13-C15 alkyl benzoate2.png",
        description: "A lightweight, fast-absorbing emollient that provides a silky, non-greasy finish. Common in sunscreens and lotions for improving texture and spreadability."
      },


      {
        id: 49,
        name: "Ethyloxydiglycol",
        price: 40000,
        unit: "per liter",
        category: "Liquids/Oils",
        image: "/assets/Ethyloxydiglycol2.png",
        description: "A solvent and penetration enhancer that helps active ingredients absorb deeper into the skin. Also improves formula clarity and stability in serums and gels."
      },

      {
        id: 50,
        name: "SAP",
        price: 150000,
        unit: "per kg",
        category: "Specialty",
        image: "/assets/SAP.png",
        description: "An antioxidant Vitamin C derivative known for brightening, reducing acne, and supporting collagen production. More stable and less irritating than pure ascorbic acid."
      },

      {
        id: 51,
        name: "MAP",
        price: 170000,
        unit: "per kg",
        category: "Specialty",
        image: "/assets/MAP.png",
        description: "A stable, gentle form of Vitamin C that brightens skin, improves uneven tone, and fights free radicals. Ideal for sensitive skin and daytime formulations."
      },

      {
        id: 52,
        name: "Dipotassium glycyrrhizinate",
        price: 150000,
        unit: "per kg",
        category: "Specialty",
        image: "/assets/Dipotassium glycyrrhizinate.png",
        description: "A soothing anti-inflammatory ingredient derived from licorice root. Helps reduce redness, calm irritation, and support sensitive or acne-prone skin."
      },

      {
        id: 53,
        name: "Ethyl ascorbic acid",
        price: 280000,
        unit: "per kg",
        category: "Specialty",
        image: "/assets/Ethyl ascorbic acid.png",
        description: "A highly stable and effective Vitamin C derivative that brightens skin, fades dark spots, and boosts collagen. Penetrates well and works across most skin types."
      },


    




  ];
  